import { createReducer, on } from '@ngrx/store';

import {
	changeElementSelection,
	fetchElementTracesAndCreate,
	fetchElementTracesSuccess,
	fetchProjectDetailsSuccess,
	initProjectHome,
} from './home.actions';
import { HomeSliceState } from './home.state';

export const homeReducer = createReducer<HomeSliceState>(
	new HomeSliceState(),
	on(initProjectHome, (state) => state.setLoading(true)),
	on(changeElementSelection, (state, action) =>
		state.setSelectedElement(action.element)
	),
	on(fetchProjectDetailsSuccess, (state, action) =>
		state
			.setMetadata(action.metadata)
			.setSelectedElement(action.element)
			.setElementsStat(action.stat)
			.setInitialPermissions(action.permissions)
			.setTraces(action.traces)
			.setLoading(false)
	),
	on(fetchElementTracesAndCreate, (state, action) =>
		state.setTraces(action.traces).changeCreatePermission(action.create)
	),
	on(fetchElementTracesSuccess, (state, action) =>
		state.setTraces(action.traces)
	)
);
